import React from 'react'

import i18n from 'i18n'

import {
  Tabs,
  // Dropdown, Space
} from 'antd'
// import { DeleteOutlined } from '@ant-design/icons'

import { languageMap } from 'i18n'
import classNames from 'classnames'
import { i18Key } from 'utils'
// import { notImplemented } from 'utils/ui'

import { UIGroup, ViewGroup } from 'utils/ui/propsUI'
import dataManager from 'pages/main/data/DataManager'

import settings from '../index'

import styles from './style.module.scss'
import { SettingsInterface } from '../def'

interface AISettingsProps {
  innerRef?: React.MutableRefObject<SettingsInterface | null>
  owner: any
  isMobile?: boolean
  parentLabel?: any
  idx?: string
}

interface AISettingsState {}

class SettingItem
  extends React.Component<AISettingsProps, AISettingsState>
  implements SettingsInterface
{
  state: AISettingsState = {}

  uiGroupMap: Record<string, UIGroup> = {}

  vGroupMap: Record<string, ViewGroup[]> = {}

  isUICreated: boolean = false

  editorFont: any = {}

  curValueMap: any = {}

  componentDidMount(): void {
    const { innerRef } = this.props
    if (innerRef != null) {
      innerRef.current = this
    }

    this.applySettings()

    // this.unsubscribe = reduxStore.subscribe(this.onChangeSettings);
  }

  // componentDidUpdate(prevProps) {
  //   const { mailbox, selectedEmail } = this.props
  // }

  componentWillUnmount(): void {
    // if (this.unsubscribe != null) {
    //   this.unsubscribe();
    // }
  }

  // onChangeSettings = () => {
  //   const reduxState = reduxStore.getState()
  //   const { settings } = reduxState

  //   console.log(' --- onChangeSettings : ', settings);
  // }
  createUIGroup = (): void => {
    if (this.isUICreated === true) {
      return
    }

    this.isUICreated = true

    this.createGeneralUIGroup()
    this.createLabsUIGroup()
  }

  createGeneralUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        titleKey: i18Key('settings.fields.mailList'),
        desc: null,
      }),
    ]

    const uiProps = {
      summary: {
        labelKey: i18Key('settings.fields.aiSummary'),
        readOnly: false,
        format: 'antd-switch',
        default: true,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[0],
      },
    }

    this.vGroupMap.general = vGroups

    this.uiGroupMap.general = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  createLabsUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        title: null,
        desc: null,
      }),
    ]

    const languageList = [
      { value: 'Korean', label: languageMap.ko.name },
      // { value: 'English', label: anguageMap.en.name },
      { value: 'Japanese', label: languageMap.ja.name },
    ]

    const uiProps = {
      language: {
        labelKey: i18Key('settings.fields.aiLanguage'),
        readOnly: false,
        format: 'antd-select',
        default: 'Korean',
        values: languageList,
        vGroup: vGroups[0],
      },
    }

    this.vGroupMap.labs = vGroups

    this.uiGroupMap.labs = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  applySettings = (): void => {
    const clone = settings.getAll()
    this.curValueMap = { ...clone.ai }
    Object.keys(this.uiGroupMap).forEach((key) => {
      this.uiGroupMap[key].setValue(clone.ai, true)
    })
  }

  onPropsChange = (key: string, value: any): void => {
    const { owner } = this.props
    const propValues = { ...owner.defaultValues.ai, ...owner.newValues.ai }
    propValues[key] = value

    // if (owner != null && owner.onChangeValue != null) {
    //   owner.onChangeValue(key, value)
    // }
    if (owner != null && owner.onChangeValue != null) {
      owner.onChangeValue('ai', { ...propValues })
    }
  }

  initAllowedSenders = (): void => {
    dataManager.clearAllowedSenderData()
  }

  getTabsAttrs = (): any => {
    const { owner, isMobile, parentLabel, idx } = this.props
    const { t } = i18n

    if (this.isUICreated === false) {
      this.createUIGroup()
    }

    let defaultActiveKey: string | null = null
    const { selectedTabs } = owner
    if (selectedTabs != null && selectedTabs.length > 1) {
      defaultActiveKey = selectedTabs[1]
    }

    const items = [
      {
        key: 'general',
        label: (
          <div className={classNames('tabItem', 'general', styles.general)}>
            <div className={classNames(styles.label)}>{i18n.t('settings.aiTabs.common')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'general', styles.general)}>
            {this.uiGroupMap.general.getElement()}
          </div>
        ),
      },
      {
        key: 'labs',
        label: (
          <div className={classNames('tabItem', 'labs', styles.labs)}>
            <div className={classNames(styles.label)}>{t('settings.aiTabs.labs')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'labs', styles.labs)}>
            {this.uiGroupMap.labs.getElement()}
          </div>
        ),
      },
    ]

    const tabsAttrs: any = {
      className: classNames('subTabs'),
      items,
      centered: true,
      tabPosition: 'left' as const,
      tabBarExtraContent: isMobile ? { left: parentLabel } : null,
      // onChange: (activeKey) => {
      // },
      onTabClick: (activeKey: string) => {
        const item = items.find((item) => item.key === activeKey)
        if (item != null) {
          const index = parseInt(idx as string, 10)
          owner.mobileViewObj.setKey(1, activeKey, [parentLabel, item.label], index)
        }
      },
    }

    if (defaultActiveKey != null) {
      tabsAttrs.defaultActiveKey = defaultActiveKey
    }

    return tabsAttrs
  }

  render(): React.ReactNode {
    const tabsAttrs = this.getTabsAttrs()

    return (
      <div className={classNames(styles.ai)}>
        <Tabs {...tabsAttrs} />
      </div>
    )
  }
}

export default SettingItem
